import { all, fork } from 'redux-saga/effects'
import { homeWatchers } from '../container/Home/saga'

export const rootSaga = function* root() {
    yield all([fork(homeWatchers)])
    // yield all([fork(mappingWatchers)])
}